import React, { useContext } from 'react';
import {
  Flex,
  Avatar as ChakraAvatar,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
  MenuDivider,
  Icon,
  Tooltip,
} from '@chakra-ui/react';
import { Link, useHistory } from 'react-router-dom';
import { AiFillExclamationCircle } from 'react-icons/ai';
import { ROUTER_PATHS } from '../../constants';
import { useAuth } from '../../hooks/useAuth';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';

export const Avatar: React.VFC = () => {
  const history = useHistory();
  const { signOut, user, clearLocalStorage } = useAuth();

  const { apply } = useContext(FilterContext);
  function handleSignOut() {
    apply({
      newgroups: [],
      newbranches: [],
      newheadOffices: [],
    });
    localStorage.removeItem('groups');
    localStorage.removeItem('headOffices');
    localStorage.removeItem('branches');
    signOut();
    history.replace(ROUTER_PATHS.LOGIN);
  }

  return (
    <>
      {!user.multifator && user.type === 'Cliente' && (
        <Tooltip
          label="Habilite o acesso multifator para elevar o nível de segurança de suas credenciais."
          fontSize="md"
          hasArrow
          maxWidth="200px"
        >
          <span>
            <Icon as={AiFillExclamationCircle} color="yellow" w={6} h={6} />
          </span>
        </Tooltip>
      )}
      <Menu>
        <MenuButton>
          <Flex align="center" gridGap="2">
            <Text fontSize={{ lg: 'sm', md: 'sm' }} color="white">
              {user.name}
            </Text>
            <ChakraAvatar name={user.name} size="xs" />
          </Flex>
        </MenuButton>
        <MenuList>
          <MenuGroup>
            <Link to={ROUTER_PATHS.PORTAL.PROFILE}>
              <MenuItem>Editar Perfil</MenuItem>
            </Link>
          </MenuGroup>
          <MenuDivider />
          <MenuGroup>
            <MenuItem onClick={() => handleSignOut()}>Sair</MenuItem>
          </MenuGroup>
        </MenuList>
      </Menu>
    </>
  );
};
